import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import FullMailBodyTemplateTabs from "@pages/email/common/view/FullMailBodyTemplateTabs";
import {SaveInviteJobMailTemp} from "@pages/email/common/Service";
import FullMailBasicInfo from "@pages/email/common/view/FullMailBasicInfo";
import FullMailSubjectTemp from "@pages/email/common/view/FullMailSubjectTemp";
import FullMailChooseYourEmails from "@pages/email/common/view/FullMailChooseYourEmails";
import FullMailChooseYourSignatures from "@pages/email/common/view/FullMailChooseYourSignatures";

const InitMailTemplate = {
    id: "",
    name: "",
    note: "",
    subject: "",
    signature_body: "",
    job_table_body: "",
    strangle_candidate_body: "",
    not_gp_candidate_body: "",
    gp_candidate_body: "",
    email2_instructor_body: "",
    sending_emails: "",
}

const InitMailContent = {
    strangle_candidate_body: "",
    not_gp_candidate_body: "",
    gp_candidate_body: "",
    email2_instructor_body: "",
}

const UpdateFullMailTemplateModal = (props) => {
    const [mailTemplate, setMailTemplate] = useState(InitMailTemplate);
    const [mailContent, setMailContent] = useState(InitMailContent);
    const [mailSubject, setMailSubject] = useState("");
    const [isAddMode, setAddMode] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {template, isShow, onClose} = props

    const moveDataMailContent = (objOut, objIn) => {
        objOut.strangle_candidate_body = objIn.strangle_candidate_body
        objOut.not_gp_candidate_body = objIn.not_gp_candidate_body
        objOut.gp_candidate_body = objIn.gp_candidate_body
        objOut.email2_instructor_body = objIn.email2_instructor_body
        return objOut
    }

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (template) {
            setMailTemplate({...template})
            setAddMode(!template.id)
            moveDataMailContent(mailContent, template)
            setMailContent({...mailContent})
            setMailSubject(template.subject)
        }
    }, [template]);

    const onCloseModal = (reload) => {
        setMailTemplate(InitMailTemplate)
        setMailContent(InitMailContent)
        onClose(reload)
    }

    const onUpdateRequest = () => {
        mailTemplate.subject = mailSubject
        moveDataMailContent(mailTemplate, mailContent)
        SaveInviteJobMailTemp(mailTemplate, function (stsCode) {
            if (stsCode === ResponseCode.SUCCESS) {
                onCloseModal(stsCode === ResponseCode.SUCCESS)
            }
        })
    }

    const onChangeMailContent = (content) => {
        moveDataMailContent(mailContent, content)
        setMailContent({...mailContent})
    }

    const onChangeSendingEmails = (content) => {
        mailTemplate.sending_emails = content

        // todo: Xóa vì nếu set sẽ bị reset dữ liệu mailTemplate
        // setMailTemplate({...mailTemplate})
    }

    const onChangeBasicInfo = (tempBasicInfo) => {
        mailTemplate.name = tempBasicInfo.name
        mailTemplate.note = tempBasicInfo.note
        setMailContent({...mailContent})
    }

    const onChangeSubject = (changeContent) => {
        setMailSubject(changeContent)

        // todo: Xóa vì nếu set sẽ bị reset dữ liệu mailTemplate
        // setMailTemplate({...mailTemplate})
    }

    const onChangeSignatureBody = (body) => {
        mailTemplate.signature_body = body

        // todo: Xóa vì nếu set sẽ bị reset dữ liệu mailTemplate
        // setMailTemplate({...mailTemplate})
    }

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={() => onCloseModal()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>{"Thông tin mail template"}</Modal.Title>
                    <Button variant='secondary' onClick={() => onCloseModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <FullMailBasicInfo template={mailTemplate} onChange={(basicInfo) => onChangeBasicInfo(basicInfo)}/>
                    <FullMailSubjectTemp content={mailSubject} onChange={(content) => onChangeSubject(content)}/>
                    <FullMailBodyTemplateTabs content={mailContent} onChange={(content) => onChangeMailContent(content)}/>
                    <FullMailChooseYourSignatures content={mailTemplate.signature_body} onChange={(content) => onChangeSignatureBody(content)}/>
                    <FullMailChooseYourEmails sendingEmails={mailTemplate.sending_emails} onChange={(content) => onChangeSendingEmails(content)}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={isLoading}
                            onClick={() => {
                                onUpdateRequest()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UpdateFullMailTemplateModal;
